import React from 'react';
import { getRowerColorByKey } from '../../utils/rowerColors';
import { RowerDot } from './RowerDot';

interface RowerLegendBadgeProps {
  rowerKey: string;
  rowerNumber: string | number;
  className?: string;
}

/**
 * RowerLegendBadge - Standardized rower indicator that matches Chart.js legend styling
 *
 * This component creates a consistent rower indicator that visually matches the
 * Chart.js legend badges used in PowerAnalysisChart and Gate Force charts.
 *
 * Design matches Chart.js legend configuration:
 * - Small circular indicator (12px)
 * - Subtle styling with border
 * - Consistent with chart legend appearance
 */
const RowerLegendBadge: React.FC<RowerLegendBadgeProps> = ({
  rowerKey,
  rowerNumber,
  className = '',
}) => {
  const rowerColor = getRowerColorByKey(rowerKey);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Unified ring style to match Chart.js legend */}
      <RowerDot color={rowerColor} size="md" variant="ring" title={`Rower ${rowerNumber}`} />
      <span className="text-sm text-gray-600 font-medium">R{rowerNumber}</span>
    </div>
  );
};

export default RowerLegendBadge;
